import Web3 from "web3";

export const web3Instance = new Web3(window.ethereum);
